<ng-container *ngIf="personnelReport.length || dprPersonnel.comment">
  <!--Basic Personnel-->
  <table *ngIf="subprojectConfiguration.personnelVersion === PersonnelVersion.Basic" class="layout-fixed striped">
    <colgroup>
      <col class="width-30" />
      <col class="width-10" />
      <col class="width-10" />
      <col class="width-10" />
      <col class="width-40" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="5">
          <h3>{{subprojectConfiguration.customNames.personnelTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="personnelReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{entityColName}}</td>
          <td class="text-center">{{StaticMessage.PreviousColumn | staticMessage}}</td>
          <td class="text-center">{{StaticMessage.TodayColumn | staticMessage}}</td>
          <td class="text-center">{{StaticMessage.TotalColumn | staticMessage}}</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let personnel of personnelReport" [ngClass]="{'summary-total-row': personnel.isTotal}">
        <td class="accent">{{personnel.name}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.previous}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.today}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.total}}</td>
        <td>{{personnel.comment | trim}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprPersonnel.comment">
      <tr>
        <td colspan="5">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprPersonnel.comment">
      <tr>
        <td colspan="5" class="white-space-pre-wrap" [innerHTML]="(dprPersonnel.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>

  <!--Stock Personnel-->
  <table *ngIf="subprojectConfiguration.personnelVersion === PersonnelVersion.Stock" class="layout-fixed striped">
    <colgroup>
      <col style="width: 18%" />
      <col style="width: 7%" />
      <col style="width: 7%" />
      <col style="width: 7%" />
      <col style="width: 7%" />
      <col style="width: 7%" />
      <col style="width: 10%" />
      <col style="width: 10%" />
      <col style="width: 20%" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="9">
          <h3>{{subprojectConfiguration.customNames.personnelTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="personnelReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{entityColName}}</td>
          <td class="text-center">{{hoursPrShiftColName}}</td>
          <td class="text-center" i18n="@@report.reportPersonnel.colPaxStartOfDay">Pax start of day</td>
          <td class="text-center" i18n="@@report.reportPersonnel.colPaxSigningOn">Pax signing on</td>
          <td class="text-center" i18n="@@report.reportPersonnel.colPaxSigningOff">Pax signing off</td>
          <td class="text-center" i18n="@@report.reportPersonnel.colPaxEndOfDay">Pax end of day</td>
          <td class="text-center">{{manHoursCurrentDayColName}}</td>
          <td class="text-center">{{manHoursTotalToDateColName}}</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let personnel of personnelReport" [ngClass]="{'summary-total-row': personnel.isTotal}">
        <td class="accent">{{personnel.name}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.workedHours}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">
          {{personnel.dailyStockDetails.totalStartOfDay}}
        </td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.added}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.used}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">
          {{personnel.dailyStockDetails.totalEndOfDay}}
        </td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">
          {{(personnel.workedHoursDetails.total | number: '1.2-2') ?? "-"}}
        </td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">
          {{personnel.workedHoursDetails.totalToDate | number: '1.2-2'}}
        </td>
        <td>{{personnel.comment | trim}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprPersonnel.comment">
      <tr>
        <td colspan="9">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprPersonnel.comment">
      <tr>
        <td colspan="9" class="white-space-pre-wrap" [innerHTML]="(dprPersonnel.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>

  <!--Classic Personnel-->
  <table *ngIf="subprojectConfiguration.personnelVersion === PersonnelVersion.Classic" class="layout-fixed striped">
    <colgroup>
      <col style="width: 18%" />
      <col style="width: 13%" />
      <col style="width: 13%" />
      <col style="width: 16%" />
      <col style="width: 16%" />
      <col style="width: 17%" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="6">
          <h3>{{subprojectConfiguration.customNames.personnelTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="personnelReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{entityColName}}</td>
          <td class="text-center">{{hoursPrShiftColName}}</td>
          <td class="text-center" i18n="@@report.reportPersonnel.colPaxCurrentDay">Pax current day</td>
          <td class="text-center">{{manHoursCurrentDayColName}}</td>
          <td class="text-center">{{manHoursTotalToDateColName}}</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let personnel of personnelReport" [ngClass]="{'summary-total-row': personnel.isTotal}">
        <td class="accent">{{personnel.name}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.workedHours}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">{{personnel.currentDay}}</td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">
          {{(personnel.workedHoursDetails.total | number: '1.2-2') ?? "-"}}
        </td>
        <td [ngClass]="personnel.isTotal ? 'accent text-center' : 'text-center'">
          {{personnel.workedHoursDetails.totalToDate | number: '1.2-2'}}
        </td>
        <td>{{personnel.comment | trim}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprPersonnel.comment">
      <tr>
        <td colspan="6">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprPersonnel.comment">
      <tr>
        <td colspan="6" class="white-space-pre-wrap" [innerHTML]="(dprPersonnel.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>
</ng-container>
